import { render } from "./CreateExitDeclarationModal.vue?vue&type=template&id=22b1b650"
import script from "./CreateExitDeclarationModal.vue?vue&type=script&lang=js"
export * from "./CreateExitDeclarationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__